<template>
 <div class="profile">
    <LoginHeader></LoginHeader>
    <div class="content">
        <!-- logo -->
        <div  class="logo">
            <img class="logoImg" src="http://www.lungchuenjz.cn/Content/lc/images/logo400.png" alt="">
        </div>
        <!-- login-box -->
        <div class="loginBox">
            <div class="boxInner" @click="wxlogin">
             <img src="http://www.lungchuenjz.cn/Content/lc/images/weixin.png" alt="">
             <p>使用微信安全登录，免注册，更快捷！</p>
            </div>
        </div>
    </div>
 </div>
    
</template>

<script>
import LoginHeader from '../../components/LoginHeader/LoginHeader'
import { Toast } from 'vant'
export default {
    components:{
         LoginHeader
    },
    data () {
      return {
       
      }
    },
    methods: {
      wxlogin () {
          if (process.env.NODE_ENV === 'development') {
          var p = prompt('请输入测试用电话号码', '')
          this.$axios.get('/api/DjUser/GetTestUserInfo',{
            params: {
              CustomerPhone: p
            }
          }).then((res) => {
      
             //console.log(res.data)

            if(res.data.type == 1){
              const { Token } = res.data
              // console.log(Token)
              // 存储到ls
              localStorage.setItem('kjToken', Token)
              this.cookieUtil.setCookie('kjToken', Token)
              this.$store.dispatch('getUser', res.data)
              this.$axios.defaults.headers.common['Authorization'] = localStorage.getItem('kjToken') || this.cookieUtil.getCookie('kjToken')

              if (localStorage.getItem('loginPath') || this.cookieUtil.getCookie('loginPath')) { //有登陆前的路径
                let path = localStorage.getItem('loginPath') || this.cookieUtil.getCookie('loginPath')
                this.$router.replace(path)
                localStorage.removeItem('loginPath')
                this.cookieUtil.delCookie('loginPath')
              }else{
                this.$router.replace("/profile")
              }
              
            }else{
              
              Toast('登录失败！');
            }
              
             
        })

        } else {
          window.location.href = '/DjLogin/WxLogin'
          //this.$router.replace("/DjLogin/WxLogin")
        }

        
      }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.profile
  background: rgb(240, 240, 240)
  height: 100vh
  .content
    width: 100%
    padding 0px 10px
    box-sizing border-box
    .logo
      margin: auto
      width: 197px
      height: 64px
      
      padding 0px 10px
      .logoImg
       margin-top: 40px
       width: 197px
       height: 64px
    .loginBox
      margin: auto
      -webkit-border-radius: 8px
      background: white
      width: 99%
      height: 180px
      margin-top: 60px
      padding: 20px
      box-sizing: border-box
      text-align: center
      color #999
      font-size 14px
      border: 1px solid #d7d7d7
      .boxInner img
         margin-bottom: 16px
         width 100px
</style>



// WEBPACK FOOTER //
// src/pages/wxLogin/wxLogin.vue